import { Component, Input } from '@angular/core';
import { OrderStatus } from '../../interface/order.interface';
import { OrderShipping } from '../../interface/order-shipping.interface';

@Component({
  selector: 'app-shipping-status',
  templateUrl: './shipping-status.component.html',
  styleUrl: './shipping-status.component.scss'
})
export class ShippingStatusComponent {
  @Input() data: OrderShipping[] = []

}
